import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { CarState } from './types';

type Variables = { id: number; reservationId: number; action: string };
type Response = CarState;

export const useCarSecurity = createMutation<Response, Variables, AxiosError>({
  mutationFn: async ({ id, reservationId, action }) =>
    client({
      url: `v2/cars/${id}/security`,
      method: 'POST',
      data: {
        reservation_id: reservationId,
        action,
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
